import React, { FC, useMemo, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { PostCategoryFragmentFragment, PostsNavQueryQuery } from "@graphqlTypes"

import { Icon, ICON_TYPES, SubNav, SubNavItemType } from '@helpscout/hs-marketing-shared-components'

import AnchorLink from '@components/AnchorLink/AnchorLink'

import "./PostsNav.scss"
import { generateConditionalClassName, isClientSide } from '@utils'
import SearchInterface from '@components/SearchInterface/SearchInterface'

type PostsNavProps = {
  currentCategorySlug?: PostCategoryFragmentFragment["slug"]
}

const PostsNav: FC<PostsNavProps> = ({ currentCategorySlug }) => {

  const { allContentfulPostCategory: { nodes: allCategories } } = useStaticQuery<PostsNavQueryQuery>(graphql`
    query PostsNavQuery {
      allContentfulPostCategory(
        filter: {
          hideOnBlog: {ne: true}
          slug: {ne: "all"}
        }
        sort: {navPosition: ASC}
      ) {
        nodes {
          title
          slug
          permalink
        }
      }
    }
  `)

  const navItems: SubNavItemType[] = useMemo(() =>
    allCategories
      .map((category) => ({
        link: category.permalink || "",
        slug: category.slug || "",
        title: category.title || "",
      }))
    , [allCategories])

  const [isSearching, setIsSearching] = useState<boolean>(false)

  const toggleSearch = () => {
    setIsSearching(!isSearching)
  }

  return (
    <>
      <SubNav
        className="PostsNav"
        currentItemSlug={currentCategorySlug || ""}
        items={navItems}
        LinkComponent={AnchorLink}
      >
        <button
          aria-label="Open search interface"
          className={generateConditionalClassName({
            "is-searching": isSearching,
            "PostsNav--SearchButton": true,
          })}
          onClick={toggleSearch}
        >
          <Icon size="24px" type={ICON_TYPES["search"]} />
        </button>
      </SubNav>
      {isClientSide() && isSearching && <SearchInterface onClickClose={toggleSearch} />}
    </>
  )
}

export default PostsNav
